import React, { createContext, Dispatch, PropsWithChildren, useContext, useEffect, useState, useReducer } from 'react';
import { getColor, getItemFromStore } from 'helpers/utils';
import { Config, initialConfig } from 'config';
import { ACTIONTYPE, configReducer, SET_CONFIG } from 'reducers/ConfigReducer';

export interface AppContextInterFace {
  config: Config;
  configDispatch: Dispatch<ACTIONTYPE>;
  toggleTheme: () => void;
  setConfig: (payload: Partial<Config>) => void;
  getThemeColor: (name: string) => string;
  SSOLogin?: boolean;
  setSSOLogin?: (val: boolean) => void;
}

export const AppContext = createContext({} as AppContextInterFace);

const AppProvider = ({ children }: PropsWithChildren) => {
  const configState: Config = {
    isNavbarVerticalCollapsed: getItemFromStore('isNavbarVerticalCollapsed', initialConfig.isNavbarVerticalCollapsed),
    openNavbarVertical: initialConfig.openNavbarVertical,
    theme: getItemFromStore('theme', initialConfig.theme),
  };

  const [config, configDispatch] = useReducer(configReducer, configState);

  const setConfig = (payload: Partial<Config>) => {
    configDispatch({
      type: SET_CONFIG,
      payload,
    });
  };

  const toggleTheme = () => {
    configDispatch({
      type: SET_CONFIG,
      payload: {
        theme: config.theme === 'dark' ? 'light' : 'dark',
      },
    });
  };

  const getThemeColor = (name: string) => {
    return getColor(name);
  };

  useEffect(() => {
    if (config.isNavbarVerticalCollapsed) {
      document.documentElement.classList.add('navbar-vertical-collapsed');
    } else {
      document.documentElement.classList.remove('navbar-vertical-collapsed');
    }
  }, [config]);

  const [SSOLogin, setSSOLogin] = useState(() => {
    const stored = localStorage.getItem('SSOLogin');
    return stored === 'true';
  });

  useEffect(() => {
    localStorage.setItem('SSOLogin', String(SSOLogin));
  }, [SSOLogin]);

  // const [loggedIn, setLoggedIn] = useState(false)
  // const [username, setusername] = useState('')
  // useEffect(() => {
  //   // Fetch the user username and token from local storage
  //   const user = JSON.parse(localStorage.getItem('user'))
  //   console.log("User: "+JSON.stringify(user))
  //   // If the token/username does not exist, mark the user as logged out
  //   if (!user || !user.token) {
  //     setLoggedIn(false)
  //     return
  //   }

  //   // If the token exists, verify it with the auth server to see if it is valid
  //   fetch('http://localhost:5002/users/validatetoken', {
  //     method: 'POST',
  //     headers: {
  //       'Authorization': user.token,
  //     },
  //   })
  //     .then((r) => r.json())
  //     .then((r) => {
  //       setLoggedIn('success' === r.message)
  //       setusername(user.username || '')
  //     })

  // }, [])
  // console.log("AppProvider page loggedIn: "+loggedIn)

  return (
    <AppContext.Provider
      value={{
        config,
        setConfig,
        toggleTheme,
        getThemeColor,
        configDispatch,
        SSOLogin,
        setSSOLogin,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);

export default AppProvider;
